module.exports = __webpack_public_path__ + "static/media/support-icon.5fe17266.svg";